import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInfinity: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="infinity, loop, boomerang"><path d="M12 12L15.295 15.3588C17.1149 17.2137 20.0653 17.2137 21.8851 15.3588C23.7049 13.5038 23.7049 10.4962 21.8851 8.64124C20.0653 6.78625 17.1149 6.78625 15.295 8.64124L12 12ZM12 12L8.70495 8.64124C6.88515 6.78625 3.93466 6.78625 2.11485 8.64124C0.295049 10.4962 0.295049 13.5038 2.11485 15.3588C3.93466 17.2137 6.88515 17.2137 8.70495 15.3588L12 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconInfinity;
